export default {"src":"/_next/static/media/shipping1.a109b920.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};